import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "sidebar-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.75 19c0 .7.56 1.25 1.25 1.25h14c.7 0 1.25-.56 1.25-1.25V5c0-.7-.56-1.25-1.25-1.25H5c-.7 0-1.25.56-1.25 1.25v14ZM5 21.75A2.75 2.75 0 0 1 2.25 19V5A2.75 2.75 0 0 1 5 2.25h14A2.75 2.75 0 0 1 21.75 5v14A2.75 2.75 0 0 1 19 21.75H5Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9 21.75a.75.75 0 0 1-.75-.75V3a.75.75 0 0 1 1.5 0v18c0 .41-.34.75-.75.75Z"
    }, null, -1)
  ])))
}
export default { render: render }